import React from "react";
import { FaIndustry, FaBalanceScale, FaCogs } from "react-icons/fa";

// === IMPORT ALL IMAGES ===
import serviceBanner from "../assets/services/service_banner.png";

import progressive_super_cutter from "../assets/services/progressive_super_cutter.png";
import hydraulic_die_cutting from "../assets/services/hydraulic_die_cutting.png";
import hot_die_cutting_press from "../assets/services/hot_die_cutting_press.png";
import laminating_machine from "../assets/services/laminating_machine.png";

// === IMPORT QUALITY MEASUREMENT IMAGES ===
// Tambahkan file asli kamu di sini
import hardness1 from "../assets/services/hardness1.png";
import hardness2 from "../assets/services/hardness2.png";
import hardness3 from "../assets/services/hardness3.png";
import caliper from "../assets/services/caliper.png";
import steelScale from "../assets/services/steel_scale.png";

// === DATA SERVICES ===
const services = [
  {
    title: "Manufacturing",
    desc: "Produksi komponen otomotif dan elektronik dengan fasilitas modern seperti Progressive Super Cutter Machine, Hydraulic Die Cutting Machine, Hot Die-Cutting Press Machine, dan Laminating Machine.",
    icon: <FaIndustry size={32} color="#2563eb" />,
  },
  {
    title: "Quality Measurement",
    desc: "Pengujian kualitas dengan standar internasional menggunakan Hardness Tester, Push Gauge, Digital Caliper, dan Steel Scale untuk memastikan ketepatan dan konsistensi produk.",
    icon: <FaBalanceScale size={32} color="#16a34a" />,
  },
  {
    title: "Automotive & Electronic Parts Supply",
    desc: "Penyediaan berbagai komponen otomotif dan elektronik, termasuk noise, vibration, cushion, offset part, dan hardness component.",
    icon: <FaCogs size={32} color="#f59e0b" />,
  },
];

// === DATA FACILITY ===
const facilityList = [
  { title: "Progressive Super Cutter Machine", img: progressive_super_cutter },
  { title: "Hydraulic Die Cutting Machine", img: hydraulic_die_cutting },
  { title: "Hot Die Cutting Press Machine", img: hot_die_cutting_press },
  { title: "Laminating Machine", img: laminating_machine },
];

// === FACILITY OF QUALITY MEASUREMENT ===
const qualityMeasurement = [
  {
    title: "Hardness Tester Measurements & Push Gauge Measurements",
    images: [hardness1, hardness2, hardness3],
  },
  {
    title: "Digital Caliper Measurements",
    images: [caliper],
  },
  {
    title: "Steel Scale Measurements",
    images: [steelScale],
  },
];

const ServiceALL = () => {
  return (
    <section
      id="services"
      style={{
        paddingTop: "100px",
        backgroundColor: "white",
      }}
    >
      {/* === Banner === */}
      <div
        className="service-banner"
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          backgroundImage: `url(${serviceBanner})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>

        <h1
          style={{
            position: "relative",
            fontSize: "2.5rem",
            fontWeight: "bold",
            zIndex: 1,
            textShadow: "2px 2px 5px rgba(0,0,0,0.5)",
          }}
        >
          Our Services
        </h1>
      </div>

      {/* === ONE BACKGROUND FOR ALL SECTIONS === */}
      <div
        style={{
          padding: "4rem 2rem",
          background: "linear-gradient(135deg, #bbf7d0, #fef08a)",
        }}
      >
        {/* ======================== */}
        {/*     WHAT WE OFFER       */}
        {/* ======================== */}

        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "2.3rem",
              fontWeight: "bold",
              color: "#111827",
              margin: 0,
            }}
          >
            What We Offer
          </h2>
          <p
            style={{
              fontSize: "1rem",
              color: "#374151",
              marginTop: "0.5rem",
            }}
          >
            Providing high quality manufacturing and supporting services
          </p>
        </div>

        {/* GRID SERVICES */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "2rem",
            maxWidth: "1100px",
            margin: "0 auto",
          }}
        >
          {services.map((service, i) => (
            <div key={i} className="animated-card">
              <div style={{ marginBottom: "1rem" }}>{service.icon}</div>

              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  color: "#111827",
                  marginBottom: "0.5rem",
                }}
              >
                {service.title}
              </h3>

              <p
                style={{
                  color: "#4b5563",
                  fontSize: "0.95rem",
                  lineHeight: "1.6",
                  textAlign: "justify",
                }}
              >
                {service.desc}
              </p>
            </div>
          ))}
        </div>

        {/* SPACER */}
        <div style={{ height: "70px" }}></div>

        {/* ======================== */}
        {/*  FACILITY OF PRODUCTION */}
        {/* ======================== */}

        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "2.3rem",
              fontWeight: "bold",
              color: "#111827",
              margin: 0,
            }}
          >
            Facility of Production
          </h2>
          <p
            style={{
              fontSize: "1rem",
              color: "#374151",
              marginTop: "0.5rem",
            }}
          >
            Our high-performance and modern production machines
          </p>
        </div>

        {/* GRID FACILITY */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "2rem",
            maxWidth: "1100px",
            margin: "0 auto",
          }}
        >
          {facilityList.map((item, i) => (
            <div key={i} className="animated-card">
              <img
                src={item.img}
                alt={item.title}
                style={{
                  width: "100%",
                  height: "180px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  marginBottom: "1rem",
                }}
              />
              <h3
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  color: "#111827",
                }}
              >
                {item.title}
              </h3>
            </div>
          ))}
        </div>

        {/* SPACER */}
        <div style={{ height: "70px" }}></div>

        {/* ================================ */}
        {/* FACILITY OF QUALITY MEASUREMENTS */}
        {/* ================================ */}

        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "2.3rem",
              fontWeight: "bold",
              color: "#111827",
              margin: 0,
            }}
          >
            Facility of Quality Measurements
          </h2>
          <p
            style={{
              fontSize: "1rem",
              color: "#374151",
              marginTop: "0.5rem",
            }}
          >
            Ensuring product precision with advanced measuring tools
          </p>
        </div>

        {/* GRID QUALITY MEASUREMENT */}
        {qualityMeasurement.map((tool, idx) => (
          <div key={idx} style={{ marginBottom: "3rem" }}>
            <h3
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: "#1f2937",
                marginBottom: "1rem",
                textAlign: "center",
              }}
            >
              {tool.title}
            </h3>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: `repeat(auto-fit, minmax(250px, 1fr))`,
                gap: "1.5rem",
                maxWidth: "1100px",
                margin: "0 auto",
              }}
            >
              {tool.images.map((img, i) => (
                <div key={i} className="animated-card">
                  {/* <img
                    src={img}
                    alt="Measurement Tool"
                    style={{
                      width: "100%",
                      height: "300px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      marginBottom: "0.8rem",
                    }}
                  /> */}
                  <img
                    src={img}
                    alt="Measurement Tool"
                    style={{
                      width: "100%",
                      height: "300px",
                      objectFit: "contain",
                      backgroundColor: "#f9fafb",
                      borderRadius: "10px",
                      padding: "10px",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* CSS Animation */}
      <style>{`
        .animated-card {
          background: white;
          padding: 1.8rem;
          border-radius: 14px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .animated-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 15px 35px rgba(0,0,0,0.18);
        }
      `}</style>
    </section>
  );
};

export default ServiceALL;
